module.exports = __webpack_public_path__ + "53407a05575517858a467c432f25ced3.svg";